<template>
  <a-modal v-model="showModal" class="filterModalContainer1 mobile-modal-fullscreen" :closable="false">
    <div class="d-flex align-items-center">
      <font-awesome-icon size="2x" :icon="['fal', 'times']" class="show-in-mobile font-black mr-3" @click="handleCancel" />
      <h4 class="fw700 font24 gray700 mb-0">Filter</h4>
      <button class="fw700 btn font-white p1224 font14 br6 show-in-mobile ml-auto" @click="handleApply()" :style="{ background: getPrimaryColor() }">Submit</button>
      <font-awesome-icon size="1x" :style="{ cursor: 'pointer' }" :icon="['fal', 'times']" class="hide-in-mobile font-black ml-auto" @click="handleCancel" />
    </div>
    <span class="divider"></span>
    <!-- <div class="searchfield">
          <span class="input-text">Type of Disease</span>
          <form class="nosubmit">
            <input 
                type="search"
                class="nosubmit"
                placeholder="Search"
                v-model="filtervalue1"
              >
          </form>
        </div> -->
    <div class="selectfield">
      <span class="input-text">Age</span>
      <select class="select" v-model="filtervalue2">
        <option value="undefined" disabled>Select age range</option>
        <option value="10">0-10</option>
        <option value="20">11-20</option>
        <option value="30">21-30</option>
        <option value="40">31-40</option>
        <option value="50">41-50</option>
        <option value="60">51-60</option>
        <option value="70">61-70</option>
        <option value="80">71-80</option>
        <option value="90">81-90</option>
        <option value="100">91-100</option>
      </select>
    </div>
    <div class="selectfield">
      <span class="input-text">Gender</span>
      <select class="select" v-model="filtervalue3">
        <option value="undefined" disabled>Select gender</option>
        <option value="male">Male</option>
        <option value="female">Female</option>
        <option value="other">Other</option>
      </select>
    </div>
    <!-- <div class="filters-container"  >
        <div class=" text-left pb-2 meetinput input">

        <label for="age" class="mb-1 font-weight-bold">Age</label>
        <a-select
        placeholder="Select age range"
        style="width: 539px"
        v-model="filtervalue2"
        >
        <a-select-option value="">Select age range</a-select-option>
        <a-select-option value="10">0-10</a-select-option>
        <a-select-option value="20">11-20</a-select-option>
        <a-select-option value="30">21-30</a-select-option>
        <a-select-option value="40">31-40</a-select-option>
        <a-select-option value="50">41-50</a-select-option>
        <a-select-option value="60">51-60</a-select-option>
        <a-select-option value="70">61-70</a-select-option>
        <a-select-option value="80">71-80</a-select-option>
        <a-select-option value="90">81-90</a-select-option>
        <a-select-option value="100">91-100</a-select-option>
        </a-select>
        </div>


        <div class=" text-left pb-2 meetinput input">
        <label for="username" class="mb-1 font-weight-bold">Gender</label>
        <a-select
        placeholder="Select gender"
        style="width: 539px"
        v-model="filtervalue3"
        >
        <a-select-option value="">Select gender</a-select-option>
        <a-select-option value="male">Male</a-select-option>
        <a-select-option value="female">Female</a-select-option>
        <a-select-option value="other">other</a-select-option>

        </a-select>
        </div>
        </div> -->
    <span class="divider"></span>
    <template #footer>
      <button class="fw700 btn font14 bg-gray200 p1224 gray600 br6" @click="handleCancel()">Cancel</button>
      <a-button class="fw700 btn font-white p1224 font14 br6 hide-in-mobile" @click="handleApply()" :style="{ background: getPrimaryColor() }"> Apply Filters </a-button>
    </template>
  </a-modal>
</template>

<script>
export default {
  name: "TreatmentFilter",
  // mounted() {
  //   if (this.answerArray.length === this.filterOptions.length) {
  //     console.log("all checked");
  //     this.checkAll = true;
  //     this.indeterminate = false;
  //   }
  // },
  props: {
    getfilteredAdvocates: Function,
    filtervalue2: String,
    filtervalue3: String,
  },
  data() {
    return {
      answerArray: [],
      showModal: false,
      // filtervalue1:undefined,
      // filtervalue2:undefined,
      // filtervalue3:undefined
    }
  },
  methods: {
    onCheckAllChange(e) {
      this.answerArray = e.target.checked ? this.filterOptions : []
      this.indeterminate = false
    },
    show() {
      this.showModal = true
      // this.checkAll = false;
    },
    handleCancel() {
      console.log("Modal Canceled")
      this.showModal = false
      // this.filtervalue1="";
      // this.filtervalue2="";
      // this.filtervalue3="";
    },
    handleApply() {
      console.log("Modal Applied")
      // this.handleAnswer(this.answerArray);
      console.log(this.filtervalue2, this.filtervalue3)
      this.getfilteredAdvocates(this.filtervalue2, this.filtervalue3)
      this.handleCancel()
    },
  },
  watch: {
    // answerArray: {
    //   handler(ans) {
    //     console.log("1", ans, this.filterOptions);
    //     if (ans.length === this.filterOptions.length) {
    //       console.log("all checked");
    //       this.checkAll = true;
    //       this.indeterminate = false;
    //     } else if (ans.length === 0) {
    //       this.checkAll = false;
    //       this.indeterminate = false;
    //     } else {
    //       this.indeterminate = true;
    //     }
    //   },
    //   immediate: true
    // },
    showModal: {
      // handler() {
      //   console.log("2", this.answerArray, this.filterOptions);
      //   if (this.answerArray.length === this.filterOptions.length) {
      //     console.log("all checked");
      //     this.checkAll = true;
      //     this.indeterminate = false;
      //   }
      // },
      immediate: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.input {
  margin-top: 24px;
}
.meetinput {
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #647490;
}
.filters-container {
  display: flex;
  flex-direction: column;
  margin-top: -34px;
}
.close {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  padding: 0px;
  width: 480px;
  height: 24px;
}

.apply-filter-btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 128px;
  height: 48px;
  background: #2a71d4;
  border-radius: 6px;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  text-transform: capitalize;
  color: #ffffff;
  border: none;
  cursor: pointer;
}

.cancel-btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 24px;
  width: 91px;
  height: 48px;
  background: #e2e8f0;
  border-radius: 6px;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  color: #47556e;
  border: none;
  cursor: pointer;
}

.footer {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 0px;
  gap: 10px;
  max-width: 539px;
  width: 100%;
  height: 48px;
  // margin-top: 104px;
}

.select {
  font-weight: 400;
  font-size: 16px;
  line-height: 32px;
  color: #94a3b8;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 12px 16px;
  gap: 10px;
  width: 100%;
  height: 56px;
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: url("../../assets/images/dropdown-arrow.png") no-repeat right;
  -webkit-appearance: none;
  appearance: none;
  background-position-x: 94%;
  outline: none;
  cursor: pointer;
  @media screen and (max-width: 600px) {
    width: 100%;
    background-position-x: 94%;
  }
}

.selectfield {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 4px;
  width: 100%;
  // width: 539px;
  height: 84px;
  margin-bottom: 24px;
}
.input-text {
  font-weight: 700;
  font-size: 16px;
  line-height: 32px;
  color: #647490;
}
.searchfield {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 4px;

  width: 539px;
  height: 92px;
}

input[type="search"]::placeholder {
  font-weight: 400;
  font-size: 16px;
  line-height: 32px;
  color: #94a3b8;
}

form.nosubmit {
  border: none;
  padding: 0;
}

input.nosubmit {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 12px 48px;
  gap: 10px;
  width: 539px;
  height: 56px;
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  font-weight: 400;
  font-size: 16px;
  line-height: 32px;
  color: #94a3b8;
  background-image: url("../../assets/images/search-grey.png");
  background-repeat: no-repeat;
  background-position: 18px;
  outline: none;
}

.divider {
  // width: 539px;
  width: 100%;
  height: 0px;
  border: 1px solid #ffffff;
}
.xmark {
  width: 12.5px;
  height: 12.54px;
  cursor: pointer;
}
.title {
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  color: #33415f;
}
.header {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  width: 100%;
  // width: 539px;
  max-height: 29px;
}

.modalContainer {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 24px;
  gap: 24px;
  position: relative;
  width: 587px;
  height: 529px;
  background: #ffffff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

.ant-modal-content {
  border-radius: 8px;
}

.fw700 {
  font-weight: 700;
}

.mainHeading {
  font-size: 24px;
  line-height: 32px;
  color: #33415f !important;
}

.subHeading {
  font-size: 16px;
  line-height: 32px;
  color: #647490 !important;
  margin-top: 45px;
}

.checkbox,
.checkboxMain {
  display: flex;
  flex-direction: column;
  gap: 24px;
  font-weight: 400;
  font-size: 34px;
  line-height: 21px;
  color: #0f1734 !important;
}

.btn {
  border-radius: 6px;
  font-size: 14px;
  line-height: 24px;
}

.cancel {
  background: #e2e8f0;
  width: 91px;
  height: 48px;

  .cancelColor {
    color: #47556e !important;
  }
}

.apply {
  background: #2a71d4;
  width: 128px;
  height: 48px;

  .applyColor {
    color: #ffffff !important;
  }
}
.ant-modal-content {
  border-radius: 8px !important;
}
.btn {
  border: none !important;
}
@media screen and (max-width: 600px) {
  .justify-content-between {
    gap: 24px;
    flex-direction: column;
  }
  .bg-gray200 {
    width: 100% !important;
    margin-bottom: 500px;
  }
}
</style>

<!-- <style lang="scss" scoped>
  .input {
  margin-top: 24px;
}
.meetinput {
 
 font-family: 'Lato';
 font-style: normal;
 font-weight: 700;
 font-size: 16px;
 line-height: 24px;
 color: #647490;
}
.filters-container {
  display: flex;
  flex-direction: column;
  margin-top:-34px;
}
.close{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  padding: 0px;
  width: 480px;
  height: 24px;
}

.apply-filter-btn{
  display: flex;
flex-direction: row;
justify-content: center;
align-items: center;
width: 128px;
height: 48px;
background: #2A71D4;
border-radius: 6px;
font-weight: 700;
font-size: 14px;
line-height: 24px;
text-align: center;
text-transform: capitalize;
color: #FFFFFF;
border: none;
cursor: pointer;

}


.cancel-btn{
display: flex;
flex-direction: row;
justify-content: center;
align-items: center;
padding: 12px 24px;
width: 91px;
height: 48px;
background: #E2E8F0;
border-radius: 6px;
font-weight: 700;
font-size: 14px;
line-height: 24px;
text-align: center;
color: #47556E;
border: none;
cursor: pointer;
}


.footer{
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 0px;
  gap: 10px;
  max-width: 539px;
  width: 100%;
  height: 48px;
  // margin-top: 104px;
}

.select{
  font-weight: 400;
font-size: 16px;
line-height: 32px;
color: #94A3B8;
box-sizing: border-box;
display: flex;
flex-direction: row;
align-items: center;
padding: 12px 16px;
gap: 10px;
width: 539px;
height: 56px;
background: #FFFFFF;
border: 1px solid #CBD5E1;
border-radius: 8px;
background: url("../../assets/images/dropdown-arrow.png") no-repeat right;
-webkit-appearance: none;
appearance: none;
background-position-x: 503.47px;
outline: none;
cursor: pointer;
}


.selectfield{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 4px;
  width: 100%;
  // width: 539px;
  height: 84px;
}
.input-text{
  font-weight: 700;
  font-size: 16px;
  line-height: 32px;
  color: #647490;
}
.searchfield{
  display: flex;
flex-direction: column;
align-items: flex-start;
padding: 0px;
gap: 4px;

width: 539px;
height: 92px;
}

input[type="search"]::placeholder {
  font-weight: 400;
  font-size: 16px;
  line-height: 32px;
  color: #94A3B8;
}

form.nosubmit {
 border: none;
 padding: 0;
}

input.nosubmit {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 12px 48px;
  gap: 10px;
  width: 539px;
  height: 56px;
  background: #FFFFFF;
  border: 1px solid #CBD5E1;
  border-radius: 8px;
  font-weight: 400;
  font-size: 16px;
  line-height: 32px;
  color: #94A3B8;
  background-image:url("../../assets/images/search-grey.png") ;
  background-repeat: no-repeat;
  background-position: 18px;
  outline: none;
}

.divider{
  // width: 539px;
  width: 100%;
  height: 0px;
  border: 1px solid #FFFFFF;
}
.xmark{
 width:12.5px;
 height: 12.54px;
 cursor: pointer;
}
.title{
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  color: #33415F;
}
.header{
  display: flex;
flex-direction: row;
align-items: center;
padding: 0px;
width: 100%;
// width: 539px;
max-height: 29px;

}
  
.modalContainer{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 24px;
    gap: 24px;
    position: relative;
    width: 587px;
    height: 529px;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
  }

  .ant-modal-content {
    border-radius: 8px;
  }
  
  .fw700 {
    font-weight: 700;
  }
  
  .mainHeading {
    font-size: 24px;
    line-height: 32px;
    color: #33415f !important;
  }
  
  .subHeading {
    font-size: 16px;
    line-height: 32px;
    color: #647490 !important;
    margin-top: 45px;
  }
  
  .checkbox,
  .checkboxMain {
    display: flex;
    flex-direction: column;
    gap: 24px;
    font-weight: 400;
    font-size: 34px;
    line-height: 21px;
    color: #0f1734 !important;
  }
  
  .btn {
    border-radius: 6px;
    font-size: 14px;
    line-height: 24px;
  }
  
  .cancel {
    background: #e2e8f0;
    width: 91px;
    height: 48px;
  
    .cancelColor {
      color: #47556e !important;
    }
  }
  
  .apply {
    background: #2a71d4;
    width: 128px;
    height: 48px;
  
    .applyColor {
      color: #ffffff !important;
    }
  }
  </style> -->



// WEBPACK FOOTER //
// src/components/Modals/AdvocateFilter.vue